var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3833 9.51551C18.8534 7.84679 21.8155 6.875 25.0001 6.875C33.6296 6.875 40.6251 14.0105 40.6251 22.8125C40.6251 29.0162 39.4674 34.944 37.3593 40.383M11.9639 14.0233C10.3279 16.5428 9.37512 19.5642 9.37512 22.8125C9.37512 25.9313 8.49751 28.8408 6.97949 31.2979M11.1228 38.8605C14.892 34.618 17.1876 28.9888 17.1876 22.8125C17.1876 18.4115 20.6854 14.8438 25.0001 14.8438C29.3148 14.8438 32.8126 18.4115 32.8126 22.8125C32.8126 23.9322 32.768 25.0411 32.6792 26.1374M25.0008 22.8125C25.0008 30.723 22.1756 37.9606 17.4984 43.5326M31.3188 33.7654C30.1776 37.8454 28.4148 41.6582 26.1416 45.0902",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.e455da542e16f442312a214383322b54.svg";
export { ForwardRef as ReactComponent };